// extracted by mini-css-extract-plugin
export default {"button":"dp-z","reviewSort":"ep-z"};